import {EpLayer} from "./layer";
import {inventoryLocationThermalImagingTransectsFeatureStyle,} from "../styles/inventory-locations";
import {
    coordinatesToGeoJSON,
    createPolygonByLineAndWidth,
    geoJSONtoOLFeature,
    quickGeojsonPolygonUnion,
} from "../utilities";
import * as turf from '@turf/turf'

export class EpInventoryLocationTransects extends EpLayer {
    constructor(map) {
        super(map);

        this.style = inventoryLocationThermalImagingTransectsFeatureStyle;

        this.title = 'Transekty';
        this.name = 'thermal_imaging_transects';

        return this;
    }

    createSimplifiedTransectsCollection(features) {
        const left = EpInventoryLocationTransects.GenerateSimplifiedPolygons(features, 'LEFT')
        const right = EpInventoryLocationTransects.GenerateSimplifiedPolygons(features, 'RIGHT')

        const leftFeature = geoJSONtoOLFeature(left)
        leftFeature.set('side', 'LEFT')
        if(leftFeature) {
            this.source.addFeature(leftFeature);
        }

        const rightFeature = geoJSONtoOLFeature(right)
        rightFeature.set('side', 'RIGHT')
        if(rightFeature) {
            this.source.addFeature(rightFeature);
        }
    }

    static GenerateSimplifiedPolygons(features, side) {
        let coordinates = [];
        const toAppend = [];
        let index = 0;

        let polygons = [];

        features = features.sort((a, b) => a.meta.order - b.meta.order)

        for (let feature of features) {
            try {
                const poly = createPolygonByLineAndWidth(
                    coordinatesToGeoJSON(feature.coordinates, 'LineString'),
                    side,
                    side === 'LEFT' ? feature.meta.left : feature.meta.right
                );

                polygons.push(poly)

                if (index === 0) {
                    coordinates.push(poly.geometry.coordinates[0][4]);
                    coordinates.push(poly.geometry.coordinates[0][3]);

                    toAppend.push(poly.geometry.coordinates[0][0]);
                    toAppend.push(poly.geometry.coordinates[0][1]);
                } else if (index === features.length - 1) {
                    coordinates.push(poly.geometry.coordinates[0][3]);
                    coordinates.push(poly.geometry.coordinates[0][2]);
                    coordinates.push(poly.geometry.coordinates[0][1]);

                    // toAppend.push(poly.geometry.coordinates[0][2]);
                    toAppend.push(poly.geometry.coordinates[0][1]);

                } else {
                    coordinates.push(poly.geometry.coordinates[0][3]);
                    coordinates.push(poly.geometry.coordinates[0][2]);

                    toAppend.push(poly.geometry.coordinates[0][0]);
                    toAppend.push(poly.geometry.coordinates[0][1]);
                }
            } catch (err) {
            }

            index++;
        }

        coordinates = [...coordinates, ...toAppend.reverse()]

        if (coordinates.length) {
            try {
                const raw = turf.polygon([coordinates])
                return quickGeojsonPolygonUnion(turf.featureCollection([...polygons, raw]));
            } catch (err) {
                return turf.polygon([coordinates]);
            }
        }

        return null;
    }
}
